export const AUTHORIZED_PICKUP_LIST_DETAILS_MENU_LINKS = ['/AuthorizedPickupListDetailsReport']
